var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLinkArrow = function SvgLinkArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 239 239"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M205.45 19.648H69.65V.868H238.2v168.55h-18.78V32.648L13.78 238.268.3 224.788l205.15-205.14z"
  })));
};
export { SvgLinkArrow as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMjM5IDIzOSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICA8cGF0aCBkPSJNMjA1LjQ1IDE5LjY0OEg2OS42NVYuODY4SDIzOC4ydjE2OC41NWgtMTguNzhWMzIuNjQ4TDEzLjc4IDIzOC4yNjguMyAyMjQuNzg4bDIwNS4xNS0yMDUuMTR6IiBmaWxsPSJjdXJyZW50Q29sb3IiLz4KPC9zdmc+Cg==";